import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FileSizeHelper } from '../utils';

import { ModalState, ModalSettingsFileSelector } from './generic-modal.service';

@Component({
    selector: 'ep-modal-file-selector',
    styleUrl: './modal-file-selector.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './modal-file-selector.component.html'
})
export class ModalFileSelectorComponent {
  options: ModalSettingsFileSelector;
  files: File[] = [];
  tooManyfiles = false;
  tooLargeFiles = false;

  constructor(private modalState: ModalState) {
    this.options = modalState.options as ModalSettingsFileSelector;
  }

  getFiles(event: { target: { files: FileList } }) {
    const newFiles = Array.from(event.target.files);
    const sizeOfFiles = this.files.reduce((acc, f) => acc + f.size, 0);
    const sizeOfNewFiles = newFiles.reduce((acc, f) => acc + f.size, 0);

    this.tooLargeFiles = this.options.maxFileSize && sizeOfFiles + sizeOfNewFiles > this.options.maxFileSize;
    this.tooManyfiles = this.options.maxFiles && this.files.length + newFiles.length > this.options.maxFiles;

    if (!this.tooLargeFiles && !this.tooManyfiles) {
      this.files = [...this.files, ...newFiles];
    }
  }

  close() {
    this.modalState.modal.dismiss();
  }

  ok() {
    this.modalState.modal.close(this.files);
  }

  getReadableFileSize(size) {
    return FileSizeHelper.humanFileSize(size);
  }
}
